<p>view-grade-intersect-btn works!</p>
